import { Box, Button, Card, CircularProgress, Divider, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Pagination, Popover, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors"
import SearchIcon from '@mui/icons-material/Search';
import { MonthEnum } from "../../enums/monthEnum";
import { ConvertMonthTypeToNormalString } from "../../utils/convertMonthToNormalString";
import { findYearsDataFrom2023 } from "../../utils/findYearDataFrom2023";
import blue from '../../assets/images/driver-financial/blue.svg';
import TableSearchNotFound from "../../components/tableSearchNotFound";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import useRiderBalanceController from "./controller";
import TabRiderDayComponents from "./components/tabRiderDay";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import { useTranslation } from "react-i18next";
import { DriverFinancialModel } from "../../models/driverFinancial";
import { numberFormat } from "../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import { convertDateStringToNormalDateTime } from "../../utils/convertDateFormat";
import RiderBalanceDetailView from "./detail";
import { BalanceModel } from "../../models/balanceModel";


const RiderBalanceView = () => {
    const controller = useRiderBalanceController()
    const { t } = useTranslation('global')
    const TableHeadValue: string[] = [
        t("clearanceMoney_page.No"),
        t("clearanceMoney_page.Rider Name"),
        t("clearanceMoney_page.Rider Number"),
        t("clearanceMoney_page.Total Money Clearance"),
        t("clearanceMoney_page.Total Payment"),
        t("clearanceMoney_page.Number of Clearance"),
        t("clearanceMoney_page.Clearance Time"),
        "", ""
    ]

    return (
        <>
            {
                controller.openForm ? (<RiderBalanceDetailView selectedData={controller.selectedData} onClose={controller.handleCloseForm} onFetchData={controller.handleFetchData} />) : <>
                    {
                        controller.loadingData ? <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <LoadingAnimatedIcon />
                        </Box> : <><Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("clearanceMoney_page.Clearance Money Rider")}</Typography>
                                <Box sx={{ ml: 1, width: 'auto' }}>
                                    <TextField
                                        placeholder={`${t("clearanceMoney_page.Search by Name")}...`}
                                        size="small"
                                        fullWidth
                                        value={controller.searchValue}
                                        onChange={controller.handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                <TextField type="date" fullWidth
                                    inputRef={controller.startDateRef}
                                    sx={{
                                        maxWidth: 150, "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                                border: "none"
                                            }
                                        }
                                    }} size="small" label={t("allReport_page.Start Date")} InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            backgroundColor: SELECT_BACKGROUND_COLOR,
                                            borderRadius: '8px'
                                        }
                                    }} InputLabelProps={{ shrink: true }} />
                                <TextField type="date" fullWidth
                                    inputRef={controller.endDateRef}
                                    sx={{
                                        maxWidth: 150, "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                                border: "none"
                                            }
                                        }
                                    }} size="small" label={t("allReport_page.End Date")} InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            backgroundColor: SELECT_BACKGROUND_COLOR,
                                            borderRadius: '8px'
                                        }
                                    }} InputLabelProps={{ shrink: true }} />
                                <Button onClick={controller.handleFilterData} variant="contained" sx={{ textTransform: 'none' }}>Search</Button>
                            </Box>
                        </Box>
                            <Box mt={2}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ background: '#f7f7f7' }}>
                                                {
                                                    TableHeadValue?.map((item: string, ind: number) => <TableCell key={ind} sx={{ borderBottom: 'none' }}>{item}</TableCell>)
                                                }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                controller.rows?.map((row: DriverFinancialModel, index: number) => {
                                                    const { id, rider, createdAt, balanceSubmission, totalMoney } = row;
                                                    const totalMoneyForConfirmedItems = balanceSubmission
                                                        ?.filter((item: BalanceModel) => item?.confirmIsStatus === true)
                                                        .reduce((total, item) => total + (item?.totalMoney || 0), 0);
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1))}
                                                            </TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>{rider?.username}</TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>{rider?.driverNo}</TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>{numberFormat(rider?.totalBalance?.total)} {t("Kip")}</TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>
                                                                {numberFormat(totalMoneyForConfirmedItems)} {t("Kip")}
                                                            </TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>{balanceSubmission?.length}</TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>{convertDateStringToNormalDateTime(createdAt)}</TableCell>
                                                            <TableCell sx={{ borderBottom: 'none' }}>
                                                                <span style={{ width: 70, background: "#36B37E", borderRadius: '6px', padding: "5px 10px", color: 'white', display: rider?.totalBalance?.total === 0 ? "block" : "none" }}>
                                                                    {t("clearanceMoney_page.Paid")}
                                                                </span>
                                                                <span style={{ width: 70, background: "#Db1f35", borderRadius: '6px', padding: "5px 10px", color: 'white', display: rider?.totalBalance?.total !== 0 ? "block" : "none" }}>
                                                                    {t("clearanceMoney_page.Unpaid")}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                <IconButton
                                                                    size="large"
                                                                    color="inherit"
                                                                    onClick={(e: any) => controller.handleOpenMenu(e, id)}
                                                                >
                                                                    <MoreHorizIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                        {controller.isSearchNotFound && (
                                            <TableSearchNotFound
                                                searchValue={controller.searchValue}
                                                colSpan={7}
                                            />
                                        )}
                                    </Table>
                                </TableContainer>
                                <Divider />
                                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                                    <Pagination
                                        color="primary"
                                        page={controller.currentPage}
                                        onChange={controller.handleChangePage}
                                        count={controller.countPagination}
                                    />
                                </Box>
                            </Box>
                        </>
                    }
                    <Popover
                        open={Boolean(controller.openMenu)}
                        anchorEl={controller.openMenu}
                        onClose={controller.handleCloseMenu}
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                p: 1,
                                width: 140,
                                '& .MuiMenuItem-root': {
                                    px: 1,
                                    typography: 'body2',
                                    borderRadius: 0.75,
                                },
                            },
                        }}
                    >
                        <MenuItem onClick={controller.handleOpenForm}>
                            &nbsp;&nbsp;
                            {t('See Detail')}
                        </MenuItem>
                    </Popover>
                </>
            }

        </>

    )
}
export default RiderBalanceView